export default __webpack_public_path__ + "static/media/accountsLight.07a7fabc.svg";